import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import axios from "axios";
import "./ShareCardModal.css"; // קובץ סגנון נפרד אם תרצי

export default function ShareCardModal({ isOpen, onClose }) {
  const [share, setShare] = useState(false);
  const [note, setNote] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [freeText, setFreeText] = useState("");
  const [cellFriend, setCellFriend] = useState("");
  const [keyImage1, setKeyImage1] = useState("");
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [isErrorMessageDisplayed, setIsErrorMessageDisplayed] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const alertUser = (message) => {
    setIsErrorMessageDisplayed(true);
    setErrorMessage(message);
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_LOCALHOST_ADDRESS + "/PshareCardData",
          config,
        );
        const userData = response.data;

        if (userData[0].length > 0) {
          setFreeText(userData[0][0].freeText);
          setCellFriend(userData[0][0].cellFriend);
          setKeyImage1(userData[0][0].keyImage1);

          setIsDataLoaded(true);
        } else {
          // in case there is no data
        }
      } catch (error) {
        // probebly user is not authenticated or server is down
      }
    };
    loadData();
  }, []);

  const handleSubmit = async () => {
    setIsLoading(true);
    if (
      cellFriend === "0" ||
      freeText === "0" ||
      keyImage1 === "0" ||
      cellFriend.trim() == "" ||
      freeText.trim() == "" ||
      keyImage1.trim() == ""
    ) {
      alertUser(
        "כדי לשתף את הכרטיס שלך בסטטוס של דאבל, יש לוודא שיש בו טלפון של חבר ליצירת קשר, טקסט חופשי ותמונה ראשית. נא לעדכן את הפרטים החסרים ולנסות שוב.",
      );
      // setIsLoading(false);
      // return;
    } else {
      try {
        const response = await axios.post(
          process.env.REACT_APP_LOCALHOST_ADDRESS + "/PShareCard",
          {
            note: note,
          },
          config,
        );

        if (response.status === 200) {
          alertUser("תודה! ההעדפה נשמרה בהצלחה.");
        } else {
          alertUser("שגיאה בשמירה, נסה שוב מאוחר יותר.");
        }
      } catch (err) {
        console.error(err);
        alert("שגיאה בחיבור לשרת.");
      } finally {
        setIsLoading(false);
      }
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>שיתוף הכרטיס שלי בסטטוס של דאבל</h3>

        <p>בשביל שנוכל לשתף את הכרטיס שלך, צריך לראות שיש בו פרטים בסיסיים:</p>
        <div>
          <b>טלפון של חבר/ה ליצירת קשר:</b>
          {cellFriend > "0" && cellFriend.trim != ""
            ? "✅ הטלפון שמופיע הוא " + cellFriend
            : "❌ לא מופיע, נא לעדכן"}
          <br />
          <b>טקסט חופשי:</b>
          {freeText !== "0" && freeText.trim() != ""
            ? "✅ יש טקסט חופשי: " + freeText
            : "❌ אין טקסט חופשי, נא לעדכן"}
          <br />
          <b>תמונה ראשית:</b>
          {keyImage1 && keyImage1 !== "0" && keyImage1.trim() != ""
            ? "✅ יש תמונה ראשית. "
            : "❌ אין תמונה ראשית, נא לעדכן"}
        </div>
        <Link to="/pics">{"השלמת הפרטים"}</Link>
        <div
          className="mainButton"
          style={{
            textDecoration: "none",
            textAlign: "center",
            marginTop: "10px",
          }}
        >
          <a href="/myProfile" target="_blank" rel="noopener noreferrer">
            איך הפרופיל שלי נראה?{" "}
          </a>
        </div>

        <p>
          בסימון "כן" אני מבקש/ת מדאבל לשתף את הכרטיס שלי בסטטוס וערוצי המדיה של
          דאבל 💫
        </p>
        <div className="checkbox-row">
          <input
            type="checkbox"
            checked={share}
            onChange={(e) => setShare(e.target.checked)}
          />
          <label>אני מאשר/ת לשתף את הפרופיל שלי בסטטוסים של דאבל</label>
        </div>

        <textarea
          className="freetext"
          style={{ height: "50px" }}
          placeholder="רוצה להוסיף הערה או בקשה? (לא חובה)"
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />

        <div className="buttons">
          <button onClick={onClose}>ביטול/יציאה</button>
          <button
            style={{ background: isLoading ? "#ccc" : "var(--btn-home-color)" }}
            onClick={handleSubmit}
            disabled={isLoading}
          >
            {isLoading ? "שומר..." : "שמירה"}
          </button>
        </div>
        {isErrorMessageDisplayed && (
          <div className="error-message">
            <h5>{errorMessage} </h5>
          </div>
        )}
      </div>
    </div>
  );
}
